export default __webpack_public_path__ + "assets/images/5eeb4fe829dcb33c89133d4a05d93019.jpg";